module.exports = __webpack_public_path__ + "static/media/aoc-2020.6aa0d4d9.md";